import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { InventoryEventsGrid } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { LocationPaths } from "../utils/common";

const InventorySyncEvents = () => {
  const { setLocation } = useStateContext();
  const locationData = useLocation();

  useEffect(() => {
    if (locationData.pathname === LocationPaths.INVENTORY_EVENTS) {
      setLocation(`Bitdefender / Operations / Inventory Sync Events`);
    }
  }, []);

  return (
    <div id="inventoryEvents-container">
      <div className="ml-8">
        <gz-title fontSize="20" fontWeight="500" style={{ opacity: "0.7" }}>
          Inventory Sync Events
        </gz-title>
      </div>
      <InventoryEventsGrid />
    </div>
  );
};

export default InventorySyncEvents;
